<template>
    <div class="rounded w-full px-2">
        <table class="text-left w-full border-collapse">
            <thead>
            <tr>
                <th colspan="8" class="text-center bg-teal text-white">
                    Follow Up
                </th>
            </tr>
            <tr>
                <th class="bg-grey-lightest border-b border-grey-light"></th>
                <th class="pl-2 py-3 bg-grey-lightest border-b border-grey-light">
                    <button class="font-bold uppercase text-xs text-grey-darkest hover:text-teal hover:no-underline"
                            :class="sortBy === 'contact_name' ? 'text-teal' : ''"
                            @click="order('contact_name')">
                        Contact
                        <i class="fa fa-xs fa-chevron-down ml-2"
                           v-if="sortBy === 'contact_name' && sortDirection === 'desc'"></i>
                        <i class="fa fa-xs fa-chevron-up ml-2"
                           v-if="sortBy === 'contact_name' && sortDirection === 'asc'"></i>
                    </button>
                </th>
                <th class="py-3 bg-grey-lightest border-b border-grey-light">
                    <button class="font-bold uppercase text-xs text-grey-darkest hover:text-teal hover:no-underline"
                            :class="sortBy === 'id' ? 'text-teal' : ''"
                            @click="order('id')">
                        ProjectID
                        <i class="fa fa-xs fa-chevron-down ml-2"
                           v-if="sortBy === 'id' && sortDirection === 'desc'"></i>
                        <i class="fa fa-xs fa-chevron-up ml-2"
                           v-if="sortBy === 'id' && sortDirection === 'asc'"></i>
                    </button>
                </th>
                <th class="py-3 bg-grey-lightest border-b border-grey-light">
                    <button class="font-bold uppercase text-xs text-grey-darkest hover:text-teal hover:no-underline"
                            :class="sortBy === 'project_name' ? 'text-teal' : ''"
                            @click="order('project_name')">
                        Project Name
                        <i class="fa fa-xs fa-chevron-down ml-2"
                           v-if="sortBy === 'project_name' && sortDirection === 'desc'"></i>
                        <i class="fa fa-xs fa-chevron-up ml-2"
                           v-if="sortBy === 'project_name' && sortDirection === 'asc'"></i>
                    </button>
                </th>
                <th class="py-3 bg-grey-lightest border-b border-grey-light hidden sm:table-cell">
                    <button class="font-bold uppercase text-xs text-grey-darkest hover:text-teal hover:no-underline"
                            :class="sortBy === 'meeting_date' ? 'text-teal' : ''"
                            @click="order('meeting_date')">
                        Due Date
                        <i class="fa fa-xs fa-chevron-down ml-2"
                           v-if="sortBy === 'meeting_date' && sortDirection === 'desc'"></i>
                        <i class="fa fa-xs fa-chevron-up ml-2"
                           v-if="sortBy === 'meeting_date' && sortDirection === 'asc'"></i>
                    </button>
                </th>
                <th class="py-3 bg-grey-lightest border-b border-grey-light hidden lg:table-cell">
                    <button class="font-bold uppercase text-xs text-grey-darkest hover:text-teal hover:no-underline"
                            :class="sortBy === 'assigned' ? 'text-teal' : ''"
                            @click="order('assigned')">
                        Assigned
                        <i class="fa fa-xs fa-chevron-down ml-2"
                           v-if="sortBy === 'assigned' && sortDirection === 'desc'"></i>
                        <i class="fa fa-xs fa-chevron-up ml-2"
                           v-if="sortBy === 'assigned' && sortDirection === 'asc'"></i>
                    </button>
                </th>
                <th class="py-3 bg-grey-lightest border-b border-grey-light hidden md:table-cell">
                    <button class="font-bold uppercase text-xs text-grey-darkest hover:text-teal hover:no-underline"
                            :class="sortBy === 'stage' ? 'text-teal' : ''"
                            @click="order('stage')">
                        Project Stage
                        <i class="fa fa-xs fa-chevron-down ml-2"
                           v-if="sortBy === 'stage' && sortDirection === 'desc'"></i>
                        <i class="fa fa-xs fa-chevron-up ml-2"
                           v-if="sortBy === 'stage' && sortDirection === 'asc'"></i>
                    </button>
                </th>
                <th class="py-3 bg-grey-lightest border-b border-grey-light hidden lg:table-cell">
                    <button class="font-bold uppercase text-xs text-grey-darkest hover:text-teal hover:no-underline"
                            :class="sortBy === 'age' ? 'text-teal' : ''"
                            @click="order('age')">
                        Age
                        <i class="fa fa-xs fa-chevron-down ml-2"
                           v-if="sortBy === 'age' && sortDirection === 'desc'"></i>
                        <i class="fa fa-xs fa-chevron-up ml-2"
                           v-if="sortBy === 'age' && sortDirection === 'asc'"></i>
                    </button>
                </th>
            </tr>
            </thead>
            <tbody>
            <tr
                class="hover:bg-grey-lighter cursor-pointer"
                v-for="(project, idx) in orderedProjects(followProjects.projects)"
                @click="goToProject(project)"
                :key="idx"
            >
                <td class="pl-2 py-2 border-b" :class="Number(project.age) < 0 ? 'bg-green' : 'bg-red'"></td>
                <td class="pl-2 py-2 border-b border-grey-light text-grey-darkest text-xs">
                    {{ project.contact_name }}
                </td>
                <td class="pl-2 py-2 border-b border-grey-light text-grey-darkest text-xs">
                    {{ project.id }}
                </td>
                <td class="py-2 border-b border-grey-light text-grey-darkest text-xs">
                    {{ project.project_name }}
                </td>
                <td class="py-2 border-b border-grey-light text-grey-darkest text-xs">
                    {{ project.meeting_date }}
                </td>
                <td class="py-2 border-b border-grey-light text-grey-darkest text-xs hidden sm:table-cell">
                    {{ project.assigned }}
                </td>
                <td class="py-2 border-b border-grey-light text-grey-darkest text-xs hidden lg:table-cell">
                    {{ project.stage }}
                </td>
                <td class="py-2 border-b border-grey-light text-grey-darkest text-xs hidden md:table-cell">
                    {{ project.age }}
                </td>
            </tr>
            </tbody>
        </table>
    </div>
</template>

<script>
    export default {
        name:'project-management-dashboard-followup',
        props: ['followProjects'],
        data() {
            return {
                sortBy: null,
                sortDirection: null,
                selectedProjectStage:null
            }
        },
        mounted(){
            document.getElementsByClassName('project-management-controls')[0].click();
        },
        created(){
            this.sortBy = 'meeting_date';
            this.sortDirection = 'asc';
        },
        methods: {
            orderedProjects(projects) {
                return _.orderBy(projects, this.sortBy, this.sortDirection)
            },
            order(field) {
                if (this.sortBy === field){
                    this.sortDirection = this.sortDirection === 'asc' ? 'desc' : 'asc';
                }else{
                    this.sortBy = field;
                    this.sortDirection = 'asc';
                }
            },
            goToProject(projectManagement) {
                window.location = route('project-management.project.edit', {projectManagement: projectManagement.id, dashboard: 1});
            }
        }
    }
</script>
